import React, { useState, useEffect, Fragment } from "react";

import {
  IonCard,
  IonCardContent,
  IonButton,
  IonAvatar,
  IonIcon,
} from "@ionic/react";
import "../../../src/components/Shared/DoctorList/Components/DoctorCard/doctor-card.scss";
import "../../components/Shared/DoctorList/Components/DoctorCard/doctor-card";
import {
  DoctorDataModel,
  ShiftTime,
} from "../../components/Shared/DoctorList/Components/DoctorCard/doctor-card.model";
import {
  doctorListInputData,
  doctorListParams,
} from "../../components/Shared/DoctorList/doctor-list.model";
import { CONSTANTS } from "../../constants/callcentral.constants";
import { doctorCardService } from "../../components/Shared/DoctorList/Components/DoctorCard/doctor-card-service";
import { RolePermissionData } from "../../models/rolePermission.model";
import {
  checkmarkCircleSharp,
  closeCircleSharp,
  closeOutline,
  removeCircleSharp,
} from "ionicons/icons";
import { utilService } from "../../services/utilService";
import _ from "lodash";
import { rolePermissionsService } from "../../services/rolePermissions.service";

interface doctorCardParams {
  isFromGlobalTeamAccordion?: boolean;
  getSelectedCards: (doctorCard: DoctorDataModel) => void;
  doctorData: any;
  doctorListInputDetails?: doctorListInputData;
  rolePermissions?: RolePermissionData;
  hideFeatureButtons?: boolean;
  apiParameters?: doctorListParams;
  numberBadge?: any;
  isFromTeams?: any;
  updateTeamList?: any;
  isFromUserCard?: any;
  teamID?: any;
  teamDetails?: any;
  isFromCaseHistoryDetails?: any;
  patientID?: any;
  emsAddProvider?: any;
  updateCaseDetailsPage?: any;
  patientDataID?: any;
  caseDetailsPageProviderList?: any;
  isFromCareTeamCard?: any;
  isFromOnCallSearch?: any;
  isCancelledOrCancelled?: any;
  isFromGlobalTeamSearch?:any;
}

const TeamsDoctorCard: React.FC<doctorCardParams> = (props) => {
  const [checked, showShiftData] = useState(false);
  const [showOnlineBadge, setShowOnlineBadge] = useState(false);
  const [hideMoreButton, setHideMoreButton] = useState(false);
  const [hideLessButton, setHideLessButton] = useState(false);
  const [isShowUnlinkProviderAlert, SetIsShowUnlinkProviderAlert] =
    useState(false);
  const [otherUserList, setOtherUserList]: any = useState({});
  const [showStatusMessage, setShowStatusMessage]: any = useState(false);
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [teamListData, setTeamListData]: any = useState();
  const [profilePicData, setMapProfilePicData]: any = useState("");

  const componentName: any = props?.doctorListInputDetails?.componentName;

  useEffect(() => {
    if (!_.isEmpty(props.doctorData)) {
      doctorCardService.setInitialDoctorCardHeight(props.doctorData);
      if (props?.doctorListInputDetails?.isShowColorBadge) {
        doctorCardService.setDoctorBadgeColor(props.doctorData);
      }
      setShowOnlineBadge(
        doctorCardService.showOnlineBadge(props.doctorData, componentName)
      );
      doctorCardService.alignMoreButton(props.doctorData);
    }
    getProfilePicFormatted();
  }, [props.doctorData]);

  useEffect(() => {
    if (checked) {
      doctorCardService.alignLessButton(props.doctorData);
    } else {
      doctorCardService.alignMoreButton(props.doctorData);
    }
  }, [checked]);

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  }, []);

  useEffect(() => {
    if (showStatusMessage) {
      setShowStatusMessage(showStatusMessage);
    }
  }, [showStatusMessage]);

  const getProfilePicFormatted = () => {
    teamMatesListArr(props.doctorData);

    if (!_.isEmpty(props.doctorData.profile_pic)) {
      if (
        !props.doctorData.profile_pic.includes("://thecallcentral.com") &&
        !props.doctorData.profile_pic.includes(
          "assets/images/defaultProfilePic.png"
        )
      ) {
        props.doctorData.profile_pic =
         props.doctorData.profile_pic;
      }
    } else {
      props.doctorData.profile_pic = "assets/images/defaultProfilePic.png";
    }
    setMapProfilePicData(props.doctorData.profile_pic);
    return props.doctorData.profile_pic;
  };

  const mapProfilePicData = (profilePic: string) => {
    if (!_.isEmpty(profilePic)) {
      if (
        !profilePic.includes("://thecallcentral.com") &&
        !profilePic.includes("assets/images/defaultProfilePic.png")
      ) {
        profilePic =  profilePic;
      }
    } else {
      profilePic = "assets/images/defaultProfilePic.png";
    }
    return profilePic;
  };

  const teamMatesListArr = (object: any): any => {
    let teammatesList = {
      addedToFavorite: object.added_to_favorite,
      alternateNumber: object.alternate_number,
      canEditTeamDatetime: object.can_edit_team_datetime,
      color: object.color,
      contactPreference: object.contact_preference,
      countryCode: object.country_code,
      designation: object.designation,
      displayName: object.display_name,
      email: object.email,
      firstName: object.first_name,
      groups: object.groups,
      guid: object.guid,
      id: object.id,
      image: object.image,
      isSelected: object.isSelected,
      isTeamAdmin: object.is_team_admin,
      lastName: object.last_name,
      mobileNumber: object.mobile_number,
      numberBadge: object.numberBadge,
      onGoing: object.onGoing,
      pager: object.pager,
      profilePic: mapProfilePicData(object.profile_pic),
      profile_status_message: object.profile_status_message,
      roles: object.roles,
      scheduleNames: object.schedule_names,
      shiftTime: object.shift_time,
      speciality: object.speciality,
      statusMessageAvailable: object.status_message_available,
      teamExpiryDate: object.team_expiry_date,
      teamExpiryTime: object.team_expiry_time,
      teamStartDate: object.team_start_date,
      teamStartTime: object.team_start_time,
      teamUnlink: object.team_unlink,
      teamsAvailable: object.teams_available,
      templateAvailability: object.template_availability,
      unavailableWhenNotOncall: object.unavailable_when_not_oncall,
      unlinkTill: object.unlink_till,
      username: object.username,
    };
    setTeamListData(teammatesList);
    return teammatesList;
  };

  const mapSpecialityDetails = (speciality: any) => {
    if (!_.isEmpty(speciality)) {
      return speciality.toString();
    } else {
      return "";
    }
  };

  return (
    <>
      <div>
        <IonCard
          className={`ion-card-wrapper ${
            props.doctorData.is_team_admin ? "team-admin-highlight" : ""
          }`}
        >
          <IonCardContent>
            <div
              id={`doctor-card-${props.doctorData.guid}`}
              className={`doctor-card ${
                props.doctorData.isSelected ? "active-doctor-card" : ""
              } ${
                props.doctorData.providerAddedBy
                  ? "adjust-doctor-card-height"
                  : ""
              }
            ${
              props.isFromCareTeamCard
                ? "adjust-doctor-card-height-care-team"
                : ""
            }
            ${
              props.doctorData.templateAvailability && !props.doctorData.onGoing
                ? "adjust-doctor-card-height-not-on-call"
                : ""
            }
            `}
              onClick={(e) => {
                e.stopPropagation();
                props.getSelectedCards(props.doctorData);
              }}
            >
              {props.doctorData.providerAddedBy && (
                <div
                  className="delete-provider"
                  onClick={() => {
                    SetIsShowUnlinkProviderAlert(true);
                  }}
                >
                  <IonIcon
                    class="close-icon-provider"
                    icon={closeOutline}
                  ></IonIcon>
                </div>
              )}
              <div className="doctor-card-wrapper">
                <div className="expiry-time-alert">
                  {props.doctorData.unlink_till}
                </div>

                <div className="profile-pic-div">
                  <IonAvatar className="doctor-profile-div">
                    <img
                      src={props.doctorData.profile_pic}
                      alt="Ionic logo"
                      className="doctor-profile-image"
                      onError={(
                        e: React.SyntheticEvent<HTMLImageElement, Event>
                      ) => {
                        const target = e.target as HTMLImageElement;
                        target.src = "assets/images/defaultProfilePic.png";
                      }}
                    />
                    <div className="show-badge">
                      {showOnlineBadge && props!.doctorData.onGoing && (
                        <div className="online-icon-div" title="Oncall">
                          <IonIcon icon={checkmarkCircleSharp} />
                        </div>
                      )}
                      {showOnlineBadge &&
                        !_.isEmpty(props.doctorData.templateAvailability) &&
                        !props.doctorData.onGoing && (
                          <div
                            className="template-availablity-icon-div"
                            title="Available, but not on-call"
                          >
                            <IonIcon icon={removeCircleSharp} />
                          </div>
                        )}
                      {showOnlineBadge &&
                        !props.doctorData.onGoing &&
                        _.isEmpty(props.doctorData.templateAvailability) && (
                          <div className="not-on-going-div" title="Not On-call">
                            <IonIcon icon={closeCircleSharp} />
                          </div>
                        )}
                    </div>
                  </IonAvatar>
                </div>

                <div
                  className={`doctor-details ${
                    props?.doctorListInputDetails?.isHideProfilePic
                      ? "align-to-start"
                      : ""
                  } ${
                    props?.doctorListInputDetails?.componentName ===
                    CONSTANTS.COMPONENTS.GROUP_SMS
                      ? "details-width"
                      : ""
                  }${
                    props.hideFeatureButtons &&
                    "details-width-no-feature-buttons"
                  }`}
                >
                  <div
                    id={`doctor-details-div-${props.doctorData.guid}`}
                    className="doctor-details-div"
                  >
                    {props?.doctorListInputDetails?.isShowColorBadge && (
                      <div
                        id={`doctor-color-badge-${props.doctorData.guid}`}
                        className="dot-circle"
                      ></div>
                    )}
                    <div className="doctor-name">
                      {props?.isFromGlobalTeamAccordion ? (
                        <div className="doctor-name-label">
                          {props.doctorData.first_name}{" "}
                          {props.doctorData.last_name}
                        </div>
                      ) : (
                        <div className="doctor-name-label">
                          {props.doctorData.firstName}{" "}
                          {props.doctorData.lastName}
                        </div>
                      )}
                    </div>
                  </div>

                  <Fragment>
                    <div className="no-shift-speciality-details">
                      {_.isEmpty(props.doctorData.speciality)
                        ? "No Speciality"
                        : mapSpecialityDetails(props.doctorData.speciality)}
                    </div>
                  </Fragment>

                  {props.doctorData?.shift_time?.length > 0 ? (
                    <div>
                      <div>
                        <div className="shift-details">
                          <div>
                            {props.doctorData.shift_time[0].start_time} -{" "}
                            {props.doctorData.shift_time[0].end_time}
                          </div>
                        </div>
                        
                        <div className="speciality-details"></div>
                      </div>
                      <div>
                        {!_.isEmpty(props.doctorData.templateAvailability) &&
                          props.doctorData?.shiftTime?.length === 1 &&
                          componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && [
                            <div className="not-oncall-div">
                              {!props.doctorData.onGoing &&
                                componentName ===
                                  CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                  <div>Not On-Call</div>
                                )}
                            </div>,
                            <div
                              className={`availability-div ${
                                _.isEmpty(props.doctorData.shiftTime) &&
                                "availability-div-no-shift"
                              }`}
                            >
                              Available At{" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.startTime
                              )}{" "}
                              --{" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.endTime
                              )}
                            </div>,
                          ]}
                      </div>
                    </div>
                  ) : (
                    <div className="no-shift-speciality-details">No Shift</div>
                  )}
                  {props.doctorData?.shiftTime?.length > 1
                    ? [
                        <div
                          id={`more-button-div-${props.doctorData.guid}`}
                          className="more-button-div align-more-button"
                        >
                          {componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && (
                            <IonButton
                              className={
                                hideMoreButton ? "hide-display" : "more-button"
                              }
                              onClick={() => {
                                showShiftData(true);
                                setHideMoreButton(true);
                                setHideLessButton(false);
                                doctorCardService.increaseDoctorCardHeight(
                                  props.doctorData
                                );
                              }}
                            >
                              + more
                            </IonButton>
                          )}
                        </div>,
                        <div className={hideMoreButton ? "hide-display" : ""}>
                          {!_.isEmpty(props.doctorData.templateAvailability) &&
                            componentName !==
                              CONSTANTS.COMPONENTS.GROUP_SMS && [
                              <div className="not-oncall-div">
                                {!props.doctorData.onGoing &&
                                  componentName ===
                                    CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                    <div>Not On-Call</div>
                                  )}
                              </div>,
                              <div
                                className={`availability-div ${
                                  _.isEmpty(props.doctorData.shiftTime) &&
                                  "availability-div-no-shift"
                                }`}
                              >
                                Available At{" "}
                                {doctorCardService.availabilityTimeFormat(
                                  props.doctorData.templateAvailability!
                                    .startTime
                                )}{" "}
                                --{" "}
                                {doctorCardService.availabilityTimeFormat(
                                  props.doctorData.templateAvailability!.endTime
                                )}
                              </div>,
                            ]}
                        </div>,
                        <div>
                          {checked
                            ? props.doctorData.shiftTime
                                .slice(1)
                                .map((item: ShiftTime) => {
                                  return (
                                    <div>
                                      <div className="shift-details">
                                        <div>
                                          {item.startTime} - {item.endTime}
                                        </div>
                                      </div>

                                      <div className="speciality-details">
                                        <div>
                                          {doctorCardService.specialityTrim(
                                            item.group.speciality
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                            : null}
                          {checked
                            ? [
                                <div
                                  id={`less-button-div-${props.doctorData.guid}`}
                                  className="less-button-div"
                                >
                                  <IonButton
                                    className={
                                      hideLessButton
                                        ? "hide-display"
                                        : "less-button"
                                    }
                                    onClick={() => {
                                      showShiftData(false);
                                      setHideLessButton(true);
                                      setHideMoreButton(false);
                                      doctorCardService.decreaseDoctorCardHeight(
                                        props.doctorData
                                      );
                                    }}
                                  >
                                    - less
                                  </IonButton>
                                </div>,
                                <div>
                                  {!_.isEmpty(
                                    props.doctorData.templateAvailability
                                  ) && [
                                    <div className="not-oncall-div">
                                      {!props.doctorData.onGoing &&
                                        componentName ===
                                          CONSTANTS.COMPONENTS
                                            .ONCALL_LOOK_UP && (
                                          <div>Not On-Call</div>
                                        )}
                                    </div>,
                                    <div
                                      className={`availability-div ${
                                        _.isEmpty(props.doctorData.shiftTime) &&
                                        "availability-div-no-shift"
                                      }`}
                                    >
                                      Available At{" "}
                                      {doctorCardService.availabilityTimeFormat(
                                        props.doctorData.templateAvailability!
                                          .startTime
                                      )}{" "}
                                      --{" "}
                                      {doctorCardService.availabilityTimeFormat(
                                        props.doctorData.templateAvailability!
                                          .endTime
                                      )}
                                    </div>,
                                  ]}
                                </div>,
                              ]
                            : null}
                        </div>,
                      ]
                    : null}
                </div>
              </div>
            </div>
          </IonCardContent>
        </IonCard>
      </div>
    </>
  );
};

export default TeamsDoctorCard;
